// Basic
import PropTypes from 'prop-types';
// Libs
import { useNavigate } from 'react-router-dom';
// Components
import ChartCard from '@/common-utils/components/renders/chartsCards/ChartCard';
import CardRedirection from '../../common/CardRedirection';
import PieChartSkeleton from '../../common/PieChartSkeleton';
import PieChartCustom from '@/common-utils/components/renders/charts/PieChartCustom';
// Common
import RouteUrls from '@/app/root/enums/RouteUrls';
import POSTERMINAL_STATS_FIELDS from '../../../fields/PosterminalStatsFields';
// Lang
import { nsDashboard } from '@/app/i18n/namespaces';

/**
 * @param {Object} props
 * @param {Object} props.dashboardData
 * @returns {JSX} ManufacturersChart
 */
function ManufacturersChart({ dashboardData }) {
    // Hooks
    const navigate = useNavigate();

    return (
        <>
            {dashboardData.posTerminalAndSubscriptions?.isFetching &&
                <PieChartSkeleton />
            }
            {!dashboardData.posTerminalAndSubscriptions?.isFetching && (
                <ChartCard
                    title='charts.terminals.manufacturers.title'
                    tooltipEntity='charts.terminals.manufacturers.tooltip'
                    namespace={nsDashboard}
                >
                    {dashboardData.posTerminalAndSubscriptions?.data && !dashboardData.posTerminalAndSubscriptions?.error && (
                        <PieChartCustom
                            data={dashboardData.posTerminalAndSubscriptions?.data}
                            dataKey={POSTERMINAL_STATS_FIELDS.MANUFACTURER_BREAKDOWN.key}
                            chartKey='manufacturer'
                            valueKey='count'
                            namespace={nsDashboard}
                        />
                    )}
                    {dashboardData.posTerminalAndSubscriptions?.error && (
                        <CardRedirection
                            buttonEntity='redirection.pos_terminals'
                            namespace={nsDashboard}
                            onClick={() => { navigate(RouteUrls.SUBSCRIPTIONS.url); }}
                        />
                    )}
                </ChartCard>
            )}
        </>
    );
}

ManufacturersChart.propTypes = {
    dashboardData: PropTypes.object.isRequired
};

export default ManufacturersChart;